import { notification } from "antd";
import moment from "moment";
import { ApolloError } from "apollo-boost";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { FamilyStore } from "./FamilyStore";

export class UpdateUserNote {
  store: FamilyStore;
  showDlg = false;
  saving = false;

  userId?: string = undefined;
  note = "";

  constructor(store: FamilyStore) {
    makeAutoObservable(this, {});
    this.store = store;
  }

  @action show() {
    const { curUser } = this.store;
    this.userId = curUser?.user?.id;
    this.note = curUser?.profile?.note;
    this.showDlg = true;
  }

  @action save() {
    this.saving = true;
    return Api.family
      .updateUserNote(this.userId, this.note)
      .then((res) => {
        notification.success({
          message: `Success!`,
        });
        runInAction(() => {
          this.showDlg = false;
          if (!this.store.curUser.profile) this.store.curUser.profile = {};
          this.store.curUser.profile.note = this.note;
          this.store.curUser.profile.noteUpdated = moment().toISOString();
        });
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }

  @action close() {
    this.showDlg = false;
  }

  @action setNote(note) {
    this.note = note;
  }
}
